import React from 'react';
import styled from 'styled-components';

const PDFViewerTab = ({ url }) => {
  return (
    <PDFViewerContainer
      visibility="visible"
      data={`${url}#toolbar=0`}
      type="application/pdf"
      title="cert"
    />
  );
};

export default PDFViewerTab;

const PDFViewerContainer = styled.object`
  flex-grow: 1;
  width: 90%;
  margin: auto;
`;
